import {SourceVideoType} from '@/enum/SourceVideoEnum';
import {User} from '@/store/user/userModel';
import {FilterVideoType} from '@/enum/FilterVideoEnum';


export class Media {
    public mediaID: string = '';
    public recordID: string = '';
    public status: string = '';
    public jobID: string = '';
    public blobURL: string = '';
    public imageBlobURL: string = '';
    public subtitlePath: string = '';
    public type: SourceVideoType = SourceVideoType.NONE;
    public creator?: User;
    public created:number=0;
    public cdnMediaUrl: string = '';
    public progress: number = 100;
    public transcriptB64:string='';
    public avatar:string="";
    public voice:string="";
    public avatarBackground:string="";
    // is the media is saved on the server
    public saved: boolean = false;

    // if the media is validate by the user
    public validate: boolean = false;

    /**
     * SLIDE PROPERTIES
     */
    // export static of the slide
    public exportStaticUrl:string="";
    // description of the slide
    public description=""
    // title of the slide
    public title=""
    // template of the slide
    public slideTemplate=""
    // accent color of the slide
    public theme=""
    // background color of the slide
    public slideBackgroundColor=""
    public scriptSlideLayout:string="";
    public promptIllustrationGeneration:string="";
    public slideImageUrl:string="";
    public slideUrl:string="";
    public slideVideoIllustrion:boolean=false;

    // video chunk slide properties
    public fileID=""
    public videoTimestampStart=-1;
    public videoTimestampEnd=-1;

}

export class ChunkMedia {
    public mediaID: string = '';
    public blob: Blob = new Blob();
    public type: SourceVideoType = SourceVideoType.NONE;
    public lastPart = false;
    public partNumber = 0;
    public mediaCreatorMode = false;
    public weetID: string = '';
    public noiseCancelation: number = 0;
    public transcoding: boolean = false;
    public maxTime: number = -1;
    public transcriptB64="";
    public slideB64=""
    public minDuration=-1;
    public voice:string="";

}

export class PlayerMedia {
    public url: string = '';
    public media: Media;
    public mirroring: boolean = false;
    public filter: FilterVideoType = FilterVideoType.NONE;
    public type: SourceVideoType = SourceVideoType.NONE;

    constructor(media: Media) {
        this.media = media;
    }
}
